import { ApiError, apiRequest, ErrorCode, getErrorMessage } from './client';

// Error codes and error-related type definitions moved to client.ts
export { ApiError, ErrorCode, getErrorMessage };

// Player type definition
export interface Player {
  id: number;
  playerCode: string;
  apiKey: string;
  apiSecret: string;
  name?: string;
  createdAt?: string; // DB's created_at converted to camelCase for frontend
}

// Standard API response format type definition
export interface StandardResponse<T> {
  data: T;
  meta: {
    [key: string]: unknown;
    pagination?: {
      total: number;
      limit: number;
      offset: number;
    };
    message?: string;
  };
}

// Player list response type definition
export type PlayerListResponse = StandardResponse<Player[]>;

// Single player response type definition
export type PlayerResponse = StandardResponse<Player>;

// Create response type definition
export type CreateResponse = StandardResponse<{ id: number }>;

// Update/delete response type definition
export type ActionResponse = StandardResponse<{ message: string }>;

// Player create request type definition
export interface CreatePlayerRequest {
  playerCode: string;
  apiKey: string;
  apiSecret: string;
  name?: string;
}

// Player update request type definition
export interface UpdatePlayerRequest {
  playerCode?: string;
  apiKey?: string;
  apiSecret?: string;
  name?: string;
}

/**
 * Get player list
 */
export const getPlayers = (limit?: number, offset?: number): Promise<PlayerListResponse> => {
  return apiRequest<PlayerListResponse>({
    method: 'GET',
    path: '/cms/players',
    params: { limit, offset },
  });
};

/**
 * Get player by ID
 */
export const getPlayer = (id: number): Promise<PlayerResponse> => {
  return apiRequest<PlayerResponse>({
    method: 'GET',
    path: `/cms/players/${id}`,
  });
};

/**
 * Create new player
 */
export const createPlayer = (data: CreatePlayerRequest): Promise<CreateResponse> => {
  return apiRequest<CreateResponse>({
    method: 'POST',
    path: '/cms/players',
    data,
  });
};

/**
 * Update player
 */
export const updatePlayer = (id: number, data: UpdatePlayerRequest): Promise<ActionResponse> => {
  return apiRequest<ActionResponse>({
    method: 'PUT',
    path: `/cms/players/${id}`,
    data: { id, ...data },
  });
};

/**
 * Delete player
 */
export const deletePlayer = (id: number): Promise<ActionResponse> => {
  return apiRequest<ActionResponse>({
    method: 'DELETE',
    path: `/cms/players/${id}`,
  });
};
